import { PublicShell } from "../../components/Layouts";
import { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  ["What is World Help Agency?", "A structured digital participation platform that offers transparent packages, verifiable deposits and a four-level referral network."],
  ["Which network do you support?", "We use USDT on BNB Smart Chain (BEP20). Always double-check the network before sending funds."],
  ["How does deposit verification work?", "You send USDT (BEP20) to the receiving wallet shown on your deposit page and submit the transaction hash. The platform verifies the transfer against the configured contract, wallet and confirmation count."],
  ["How many confirmations are required?", "The administrator sets the required confirmation count (default 12). You can see the current value on the deposit screen."],
  ["How is daily production calculated?", "Each package has a fixed daily production. It is credited to your balance by the platform; it is never computed on the frontend."],
  ["How are referral commissions paid?", "When a referred member activates a package, the platform credits four levels of commissions using the current rates. Historical rates on prior activations never change."],
  ["How do withdrawals work?", "Submit a withdrawal request from your wallet page. The administrator reviews each request and completes the transfer manually. The transaction hash is attached when the withdrawal is marked complete."],
  ["Is my private key stored?", "No. World Help Agency never asks for or stores private keys on this platform."],
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <PublicShell>
      <main className="page">
        <div className="page-intro">
          <div className="eyebrow">COMMON QUESTIONS</div>
          <h1>Clear answers,<br /><em>no fine print.</em></h1>
          <p>Everything you need to know about packages, deposits, production, referrals and withdrawals.</p>
        </div>
        <div className="faq-list">
          {faqs.map(([q, a], i) => (
            <article key={q} className={`faq-item ${open === i ? "open" : ""}`} data-testid={`faq-item-${i}`}>
              <button className="faq-head" onClick={() => setOpen(open === i ? -1 : i)} data-testid={`faq-toggle-${i}`}>
                <span>{q}</span>
                <ChevronDown size={18} />
              </button>
              {open === i && <p className="faq-body">{a}</p>}
            </article>
          ))}
        </div>
      </main>
    </PublicShell>
  );
}
